import React from "react"
import { compareItems, rankItem } from "@tanstack/match-sorter-utils"
import { sortingFns } from "@tanstack/react-table"
import dayjs from "dayjs"

export const fuzzyFilter = (row, columnId, value, addMeta) => {
  // Rank the item

  const itemRank = rankItem(row.getValue(columnId), value)

  // Store the ranking info
  addMeta(itemRank)

  // Return if the item should be filtered in/out
  return itemRank.passed
}

export const fuzzySort = (rowA, rowB, columnId) => {
  let dir = 0

  // Only sort by rank if the column has ranking information
  if (rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(
      rowA.columnFiltersMeta[columnId],
      rowB.columnFiltersMeta[columnId]
    )
  }

  // Provide an alphanumeric fallback for when the item ranks are equal
  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir
}

export const strictListFilter = (row, columnId, value) => {

  return value.includes(row.getValue(columnId))
}

export const dateRangeFilter = (row, columnId, value) => {
  const [dateA, dateB] = value
  return (
    (!dateA || dayjs(dateA).isBefore(dayjs(row.getValue(columnId)), "day") || dayjs(dateA).isSame(dayjs(row.getValue(columnId)), "day")) &&
    (!dateB || dayjs(dateB).isAfter(dayjs(row.getValue(columnId)), "day") || dayjs(dateB).isSame(dayjs(row.getValue(columnId)), "day"))
  )
}

export const booleanFilterSelect = (row,columnId,value) =>{
  if(value === undefined || value ==='all'){
    return true
  }
  if(value === 'false'){
    return !row.getIsSelected()
  }
  return row.getIsSelected() === true
}


export const numberFilter = ( row,columnId,value )=>{
  if(value.includes('')) return true;
  let [min, max] = value.map((item)=> Number(item))
  return Number(row.getValue(columnId)) >= min && Number(row.getValue(columnId)) <= parseInt(max)
}

export const numberFinderFilter =  (row,columnId,value) =>{
  if(!value) return true
  let hValue = value.replace(/[., ]/g,'')
  let hRow = (row.getValue(columnId) + "").replace(/[., ]/g,"")
  return hRow.includes(hValue)
}